import styles from './ContactPage.module.css';

function ContactPage() {
  return (
    <div className={styles.page}>
      <section className={styles.content}>
        <h3 className={styles.label}>Call</h3>
        <h2 className={styles.value}>617-232-2116</h2>
        <h3 className={styles.label}>Mailing Address</h3>
        <h2 className={styles.value}>
          1343 Beacon Street<br />Brookline MA, 02446
        </h2>
      </section>
    </div>
  );
}

export default ContactPage;
